import { ASPECT_RATIO_THRESHOLDS } from './aspect-ratio-constants';
import { getPhotoAspectRatio } from './preview-image';

import type { ExperiencePhoto } from '../types/experience';
import type { GalleryLayout } from '../types/gallery-layout';

type PhotoOrientation = 'square' | 'vertical' | 'horizontal';

function getPhotoOrientation(photo: ExperiencePhoto): PhotoOrientation | null {
  const aspectRatio = getPhotoAspectRatio(photo);
  if (aspectRatio === null) {
    return null;
  }

  if (aspectRatio >= ASPECT_RATIO_THRESHOLDS.SQUARE_MIN && aspectRatio <= ASPECT_RATIO_THRESHOLDS.SQUARE_MAX) {
    return 'square';
  }

  if (aspectRatio < ASPECT_RATIO_THRESHOLDS.SQUARE_MIN) {
    return 'vertical';
  }

  return 'horizontal';
}

export function getPreviewLayout(photos: ExperiencePhoto[]): GalleryLayout {
  if (photos.length === 0) {
    return 'square-square';
  }

  const firstPhoto = photos[0];
  if (!firstPhoto) {
    return 'square-square';
  }

  const firstPhotoOrientation = getPhotoOrientation(firstPhoto);
  if (firstPhotoOrientation === null) {
    return 'square-square';
  }

  if (firstPhotoOrientation === 'square') {
    return 'square-square';
  }

  if (firstPhotoOrientation === 'vertical') {
    const secondPhoto = photos[1];
    if (secondPhoto) {
      const secondPhotoOrientation = getPhotoOrientation(secondPhoto);
      if (secondPhotoOrientation === 'horizontal') {
        return 'vertical-horizontal';
      }
      if (secondPhotoOrientation === 'vertical') {
        return 'vertical-vertical';
      }
    }
    return 'vertical-vertical';
  }

  if (firstPhotoOrientation === 'horizontal') {
    const secondPhoto = photos[1];
    if (secondPhoto) {
      const secondPhotoOrientation = getPhotoOrientation(secondPhoto);

      if (secondPhotoOrientation === 'horizontal') {
        return 'horizontal-horizontal';
      }
    }
    return 'horizontal-horizontal';
  }

  return 'square-square';
}
